export const STOCKS_PER_PAGE = 15
export const TRADINGVIEW_COUNTRIES = ['US','IN']
export const PORTFOLIO_ASSET_UNKNOWN = 'Unclassified'
export const PREMIUM_PLUS_TRADING_SPECIAL_YEARLY = 'premium_plus_trading_special_yearly'
